import { create } from 'zustand'

export interface IOngoingGameStore<TGameResult> {
  /** 有未結算單待重播：下一次 spin 直接重播 ongoingGameResult、不 call placeOrder */
  isOnGoingGame: boolean
  /** 恢復的未結算單結果（server 原始格式），重播時由各遊戲自行正規化，不直接寫入 gameResult */
  ongoingGameResult: TGameResult | null
  setOngoingGameResult: (result: TGameResult) => void
  /** 重播開始時呼叫：取出結果並清除旗標，確保只重播一次 */
  consumeOngoingGameResult: () => TGameResult | null
}

export function createOngoingGameStore<TGameResult>() {
  return create<IOngoingGameStore<TGameResult>>((set, get) => ({
    isOnGoingGame: false,
    ongoingGameResult: null,
    setOngoingGameResult: result => set({ isOnGoingGame: true, ongoingGameResult: result }),
    consumeOngoingGameResult: () => {
      const result = get().ongoingGameResult
      set({ isOnGoingGame: false, ongoingGameResult: null })
      return result
    },
  }))
}
